export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48'),
	() => import('./nodes/49'),
	() => import('./nodes/50'),
	() => import('./nodes/51'),
	() => import('./nodes/52'),
	() => import('./nodes/53'),
	() => import('./nodes/54'),
	() => import('./nodes/55'),
	() => import('./nodes/56'),
	() => import('./nodes/57'),
	() => import('./nodes/58'),
	() => import('./nodes/59'),
	() => import('./nodes/60'),
	() => import('./nodes/61'),
	() => import('./nodes/62'),
	() => import('./nodes/63'),
	() => import('./nodes/64'),
	() => import('./nodes/65')
];

export const server_loads = [];

export const dictionary = {
		"/(app)": [8,[2]],
		"/(app)/admin": [9,[2,3]],
		"/(app)/admin/analytics": [10,[2,3]],
		"/(app)/admin/analytics/[tab]": [11,[2,3]],
		"/(app)/admin/diagnostics/evidence/[eventId]": [12,[2,3]],
		"/(app)/admin/evaluations": [13,[2,3]],
		"/(app)/admin/evaluations/[tab]": [14,[2,3]],
		"/(app)/admin/functions": [15,[2,3]],
		"/(app)/admin/functions/create": [16,[2,3]],
		"/(app)/admin/functions/edit": [17,[2,3]],
		"/(app)/admin/settings": [18,[2,3]],
		"/(app)/admin/settings/[tab]": [19,[2,3]],
		"/(app)/admin/users": [20,[2,3]],
		"/(app)/admin/users/[tab]": [21,[2,3]],
		"/(app)/analytics": [22,[2]],
		"/auth": [59],
		"/(app)/automations": [23,[2]],
		"/(app)/automations/[id]": [24,[2]],
		"/(app)/brand-memory-preview": [25,[2]],
		"/calendar-drawer-tester": [60],
		"/(app)/calendar": [27,[2]],
		"/(app)/channels/[id]": [28,[2]],
		"/(app)/content-factory": [29,[2]],
		"/(app)/content-factory/onboarding": [30,[2]],
		"/(app)/content-factory/postiz/integrations/social/[provider]": [31,[2]],
		"/(app)/c/[id]": [26,[2]],
		"/error": [61],
		"/(app)/home": [32,[2,4]],
		"/install-pwa": [62],
		"/(app)/notes": [33,[2,5]],
		"/(app)/notes/new": [35,[2,5]],
		"/(app)/notes/[id]": [34,[2,5]],
		"/(app)/onboarding1": [37,[2]],
		"/(app)/onboarding": [36,[2]],
		"/(app)/playground": [38,[2,6]],
		"/(app)/playground/completions": [39,[2,6]],
		"/(app)/playground/images": [40,[2,6]],
		"/s/[id]": [63],
		"/(app)/tasks": [41,[2]],
		"/telegram-editor-demo": [64],
		"/watch": [65],
		"/(app)/workspace": [42,[2,7]],
		"/(app)/workspace/functions/create": [43,[2,7]],
		"/(app)/workspace/knowledge": [44,[2,7]],
		"/(app)/workspace/knowledge/create": [46,[2,7]],
		"/(app)/workspace/knowledge/[id]": [45,[2,7]],
		"/(app)/workspace/models": [47,[2,7]],
		"/(app)/workspace/models/create": [48,[2,7]],
		"/(app)/workspace/models/edit": [49,[2,7]],
		"/(app)/workspace/prompts": [50,[2,7]],
		"/(app)/workspace/prompts/create": [52,[2,7]],
		"/(app)/workspace/prompts/[id]": [51,[2,7]],
		"/(app)/workspace/skills": [53,[2,7]],
		"/(app)/workspace/skills/create": [54,[2,7]],
		"/(app)/workspace/skills/edit": [55,[2,7]],
		"/(app)/workspace/tools": [56,[2,7]],
		"/(app)/workspace/tools/create": [57,[2,7]],
		"/(app)/workspace/tools/edit": [58,[2,7]]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
	
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';